module.exports = __webpack_public_path__ + "e40743a2964b0642bb384c84ea003df9.fbx";